const gridCellRendererDirective = {
    restrict: 'A',
    scope: false,
    link: function (scope, element, attrs) {
        const slotName = attrs.ctxGridCellRenderer;
        let displayCellElement = null;
        let editCellElement = null;

        createCellElement(slotName, e => displayCellElement = e);

        if (!slotName && scope.column.transclude.isSlotFilled('editor')) {
            scope.$watch(() => scope.item && scope.grid.isEditing(scope.item), editingThisItemChanged);
        }

        scope.getGridRowIndex = function () {
            switch (slotName) {
                case 'header': return -1;
                case 'footer': return -2;
                default: return scope.$parent.$index;
            }
        };

        scope.getGridColumnIndex = function () {
            return scope.$index;
        };

        function createCellElement(slotName, callback) {
            scope.column.transclude(scope, clone => {
                element.append(clone);
                callback && callback(clone);
            }, element, slotName);
        }

        function editingThisItemChanged(editing) {
            if (editing) {
                displayCellElement && displayCellElement.remove();
                displayCellElement = undefined;
                !editCellElement && createCellElement('editor', e => editCellElement = e);
                scope.editingItem = scope.grid.editInfo.editingItem;
            } else {
                editCellElement && editCellElement.remove();
                editCellElement = undefined;
                !displayCellElement && createCellElement('', e => displayCellElement = e);
                scope.editingItem = undefined;
            }
        }
    }
};

module.exports = function () {
    return gridCellRendererDirective;
};



// WEBPACK FOOTER //
// ./src/shared/ctxGrid/ctxGridCellRenderer.directive.js